var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.5H3.5C2.12 15.5 1 14.38 1 13V4C1 2.62 2.12 1.5 3.5 1.5H12.5C13.88 1.5 15 2.62 15 4V13C15 14.38 13.88 15.5 12.5 15.5Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4V12C15 13.38 13.88 14.5 12.5 14.5H3.5C2.12 14.5 1 13.38 1 12V4C1 2.62 2.12 1.5 3.5 1.5H12.5C13.88 1.5 15 2.62 15 4Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.5H1V4C1 2.62 2.12 1.5 3.5 1.5H12.5C13.88 1.5 15 2.62 15 4V5.5Z",
    fill: "#EF5350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.5C3.725 3.5 3.5 3.275 3.5 3V1C3.5 0.725 3.725 0.5 4 0.5C4.275 0.5 4.5 0.725 4.5 1V3C4.5 3.275 4.275 3.5 4 3.5Z",
    fill: "#FFCA28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5C11.725 3.5 11.5 3.275 11.5 3V1C11.5 0.725 11.725 0.5 12 0.5C12.275 0.5 12.5 0.725 12.5 1V3C12.5 3.275 12.275 3.5 12 3.5Z",
    fill: "#FFCA28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEvents);
export default __webpack_public_path__ + "static/media/CalendarEvents.12e2bf1a612f842eb76a8dc91725a01c.svg";
export { ForwardRef as ReactComponent };